// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11xkq","buttons":"Footer_buttons__41_ji"};